export { default } from "./InfoMessage";
